module.exports = __webpack_public_path__ + "img/noShequ.fa98c636.png";